<template>
  <Dialog
      v-model:visible="model"
      v-bind="$attrs"
      class="dialog-close-outside"
  >
    <template #container>
      <slot></slot>
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import Dialog from "primevue/dialog";

const model = defineModel<boolean>()

onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside)
})

function handleClickOutside(e: any) {

  if (e.target instanceof Element && e.target.classList.contains('p-dialog-mask')) {
    model.value = false
    // console.log('model ' + model.value)
  }
}
</script>


<style scoped lang="scss">
:global(.dialog-close-outside) {
  border-radius: 8px 0 0 8px;
  background: #fafafa;
  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.12);

  @media (max-width: 430px) {
    border-radius: 0;
  }
}
</style>
